import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import QuestionPopup from '../../../../../../common/components/questionPopup/questionPopup';
import { restrictionPopupContent } from '../contentsForPopover';
import ShowModal from '../../modal/showModal/ShowModal';
import filterConnect from '../../../../../../common/hoc/filterConnect';

// Todo добавить аббривиатуры для выбранных пунктов
const RestrictionsServiceTypes = ({ form, disabled, serviceTypes }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const values = getFieldValue('restrictionsServiceTypes');
  return (
    <Fragment>
      <span className="label">
        Ограничения по видам
        <br /> транспортных услуг:
      </span>
      <Form.Item>
        {getFieldDecorator('restrictionsServiceTypes')(
          <Select
            mode="multiple"
            dropdownClassName="select select_multiple"
            maxTagCount={1}
            placeholder="Выберите ограничения по видам услуг"
            className="longInput"
            disabled={disabled}
            showArrow
            getPopupContainer={trigger => trigger.parentNode}
          >
            {serviceTypes &&
              serviceTypes.map((item, index) => (
                <Select.Option
                  value={item.serviceTypeKey}
                  key={item.serviceTypeKey}
                >
                  {item.serviceType}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
      {disabled ? (
        <ShowModal
          title="Ограничения по видам услуг"
          content={serviceTypes}
          keys={values}
          type="serviceTypes"
        />
      ) : (
        <QuestionPopup
          title="Ограничения по видам
                        транспортных услуг"
          width="24px"
          height="24px"
          trigger="click"
          fill="#00a8ff"
        >
          {restrictionPopupContent}
        </QuestionPopup>
      )}
    </Fragment>
  );
};

export default filterConnect(RestrictionsServiceTypes, ['serviceTypes']);
